module.exports = __webpack_public_path__ + "static/img/03-1.428c97f1.png";